(() => {
  'use strict';
  const fold = value => value.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/[^a-z0-9]+/g, ' ').trim();
  const groups = [
    [['klänning','klänningar','dress','dresses'], ['klänning','klänningar','dress','dresses','ballerina','kaftanklänning','skjortklänning','shirtdress']],
    [['byxa','byxor','pants','pant','trousers','trouser'], ['byxa','byxor','pants','pant','trousers','jeans','haremsbyxa','haremsbyxor']],
    [['tröja','tröjor','sweater','sweaters','jumper','top','tops','topp','toppar'], ['tröja','tröjor','sweater','jumper','top','topp','toppar','sweatshirt','hoodie']],
    [['kjol','kjolar','skirt','skirts'], ['kjol','kjolar','skirt','skirts']],
    [['ballerina'], ['ballerina']],
    [['jeans','denim'], ['jeans','denim']],
    [['grön','gröna','green'], ['grön','gröna','green','mörkgrön','ljusgrön','bladgrön','olivgrön','khaki','kaki']],
    [['svart','svarta','black'], ['svart','svarta','black']],
    [['blå','blåa','blue'], ['blå','blåa','blue','mörkblå','ljusblå','marinblå','navy']],
    [['lila','purple','violet'], ['lila','purple','violet','ljuslila','mörklila']],
    [['vit','vita','white'], ['vit','vita','white','offwhite']],
    [['grå','gråa','grey','gray'], ['grå','grey','gray','mörkgrå','ljusgrå']],
    [['brun','bruna','brown'], ['brun','brown','mörkbrun','ljusbrun']],
    [['rosa','pink'], ['rosa','pink']],
    [['röd','röda','red'], ['röd','red','mörkröd','ljusröd']],
    [['vinröd','maroon','burgundy'], ['vinröd','maroon','burgundy']],
    [['gul','gula','yellow'], ['gul','yellow','senapsgul','mustard']],
    [['orange'], ['orange','persikofärgad']],
    [['v neck','vneck','v ringad','v ringat','v ringning'], ['V-Neck','V neck','vneck','V-ringad']],
    [['long sleeve','longsleeve','long sleeves','lång ärm','långa ärmar','långärmad','långärmat'], ['longsleeve','long sleeve','long-sleeve','långärmad','långärmat']],
    [['short sleeve','shortsleeve','short sleeves','kort ärm','korta ärmar','kortärmad','kortärmat'], ['short sleeve','short-sleeve','shortsleeve','kortärmad','kortärmat']]
  ];
  const aliases = groups.flatMap((group, index) => group[0].map(word => ({word: fold(word), index}))).sort((a, b) => b.word.split(' ').length - a.word.split(' ').length);
  const distance = (a, b) => {
    const rows = Array.from({length: a.length + 1}, (_, i) => [i]);
    for (let j = 0; j <= b.length; j++) rows[0][j] = j;
    for (let i = 1; i <= a.length; i++) for (let j = 1; j <= b.length; j++) {
      rows[i][j] = Math.min(rows[i - 1][j] + 1, rows[i][j - 1] + 1, rows[i - 1][j - 1] + (a[i - 1] === b[j - 1] ? 0 : 1));
      if (i > 1 && j > 1 && a[i - 1] === b[j - 2] && a[i - 2] === b[j - 1]) rows[i][j] = Math.min(rows[i][j], rows[i - 2][j - 2] + 1);
    }
    return rows[a.length][b.length];
  };
  const quote = word => '"' + word.replace(/["\\]/g, '\\$&') + '"';
  const clause = words => '(' + [...new Set(words)].flatMap(word => ['title','tag','product_type','variants.title'].map(field => field + ':' + quote(word))).join(' OR ') + ')';
  const expand = raw => {
    if (!raw.trim() || /[:()"*]|\b(?:AND|OR|NOT)\b/.test(raw)) return null;
    const tokens = fold(raw).split(' ');
    const clauses = [];
    const seen = new Set();
    let recognized = false;
    for (let i = 0; i < tokens.length;) {
      let hit = aliases.find(alias => alias.word === tokens.slice(i, i + alias.word.split(' ').length).join(' '));
      if (!hit) {
        const candidates = aliases.map(alias => {
          const term = tokens.slice(i, i + alias.word.split(' ').length).join(' ');
          const limit = alias.word.length >= 8 ? 2 : alias.word.length >= 4 ? 1 : 0;
          return {alias, score: Math.abs(term.length - alias.word.length) <= limit ? distance(term, alias.word) : 99, limit};
        }).filter(item => item.score > 0 && item.score <= item.limit).sort((a, b) => a.score - b.score || b.alias.word.length - a.alias.word.length);
        if (candidates.length && (!candidates[1] || candidates[0].score < candidates[1].score || candidates[0].alias.index === candidates[1].alias.index)) hit = candidates[0].alias;
      }
      if (hit) {
        recognized = true;
        if (!seen.has(hit.index)) clauses.push(clause(groups[hit.index][1]));
        seen.add(hit.index);
        i += hit.word.split(' ').length;
      } else {
        if (!['och','and','en','ett','i','med','jag','söker'].includes(tokens[i])) clauses.push(quote(tokens[i]));
        i++;
      }
    }
    return recognized ? clauses.join(' AND ') : null;
  };
  const searchUrl = (raw, query, source) => {
    const url = new URL(source || window.theme.routes.searchUrl, location.origin);
    url.searchParams.set('q', query);
    url.searchParams.set('hm_q', raw);
    url.searchParams.set('type', 'product');
    url.searchParams.set('options[prefix]', 'none');
    return url;
  };
  const navigate = form => {
    const input = form.querySelector('input[type="search"]');
    if (!input || form.querySelector('[aria-selected="true"] a')) return false;
    const raw = input.value.trim();
    const query = expand(raw);
    if (!query) return false;
    const url = searchUrl(raw, query, form.action);
    for (const [name, value] of new FormData(form)) if (name !== 'q' && name !== 'type' && name !== 'options[prefix]' && name !== 'hm_q') url.searchParams.append(name, value);
    location.assign(url.href);
    return true;
  };
  document.addEventListener('submit', event => {
    if (event.target.matches('form[role="search"]') && navigate(event.target)) event.preventDefault();
  }, true);
  const rawByQuery = new Map();
  let redirecting = false;
  const restore = () => {
    const url = new URL(location.href);
    const query = url.searchParams.get('q');
    const raw = url.searchParams.get('hm_q') || rawByQuery.get(query);
    if (raw && expand(raw) === query) {
      rawByQuery.set(query, raw);
      document.querySelectorAll('form[role="search"] input[type="search"]').forEach(input => {
        if (input.value !== query && input.value !== raw) return;
        if (input.value === query) input.value = raw;
        input.name = 'hm_q';
        let hidden = input.form.querySelector('[data-hm-query]');
        if (!hidden) {
          hidden = document.createElement('input');
          hidden.type = 'hidden';
          hidden.name = 'q';
          hidden.dataset.hmQuery = '';
          input.form.append(hidden);
        }
        hidden.value = query;
        const prefix = input.form.querySelector('input[name="options[prefix]"]');
        if (prefix) prefix.value = 'none';
      });
      document.querySelectorAll('.search-page__title, .search-page__note').forEach(element => { if (element.textContent.includes(query)) element.textContent = element.textContent.split(query).join(raw); });
      if (document.title.includes(query)) document.title = document.title.split(query).join(raw);
      document.querySelectorAll('a[href]').forEach(link => {
        if (link.getAttribute('href').startsWith('#')) return;
        const next = new URL(link.href, location.origin);
        if (next.origin === location.origin && next.pathname === url.pathname && next.searchParams.get('q') === query) {
          next.searchParams.set('hm_q', raw);
          link.href = next.href;
        }
      });
    } else if (!redirecting && document.body.classList.contains('template-search') && query && expand(query)) {
      redirecting = true;
      location.replace(searchUrl(query, expand(query), location.href).href);
    }
  };
  document.addEventListener('input', event => {
    const input = event.target;
    if (!input.matches('form[role="search"] input[type="search"]')) return;
    const hidden = input.form.querySelector('[data-hm-query]');
    if (hidden) hidden.value = expand(input.value) || input.value;
  }, true);
  customElements.whenDefined('search-form').then(() => {
    const Base = customElements.get('search-form');
    const originalSubmit = Base.prototype.submit;
    Base.prototype.submit = function () { if (!navigate(this.form)) originalSubmit.call(this); };
  });
  customElements.whenDefined('predictive-search').then(() => {
    const Predictive = customElements.get('predictive-search');
    const original = Predictive.prototype.getSearchResults;
    Predictive.prototype.getSearchResults = async function (raw) {
      const query = expand(raw);
      this.hmController?.abort();
      if (!query) return original.call(this, raw);
      this.abortController.abort();
      this.abortController = new AbortController();
      this.hmController = new AbortController();
      this.setLiveRegionLoadingState();
      const key = 'hm:' + raw;
      if (this.cachedResults[key]) return this.renderSearchResults(this.cachedResults[key]);
      const url = searchUrl(raw, query);
      url.searchParams.set('section_id', 'hm-search-suggestions');
      try {
        const response = await fetch(url.href, {signal: this.hmController.signal});
        if (!response.ok) throw new Error('Search request failed');
        const html = await response.text();
        if (this.getQuery() !== raw) return;
        const section = new DOMParser().parseFromString(html, 'text/html').querySelector('#shopify-section-hm-search-suggestions');
        if (!section?.querySelector('[data-search-results-wrapper]')) throw new Error('Search results missing');
        this.allPredictiveSearchInstances.forEach(instance => { instance.cachedResults[key] = section.innerHTML; });
        this.renderSearchResults(section.innerHTML);
      } catch (error) {
        if (error.name !== 'AbortError' && this.getQuery() === raw) original.call(this, raw);
      }
    };
  });
  const init = () => {
    restore();
    initMobileSearchScroll();
    const page = document.getElementById('SearchPage');
    if (page) new MutationObserver(restore).observe(page, {childList: true, subtree: true});
  };
  // The visible viewport excludes the mobile keyboard and browser toolbars.
  // Measure below the actual input instead of subtracting estimated header heights.
  const initMobileSearchScroll = () => {
    const popdowns = [...document.querySelectorAll('search-popdown[data-popdown-in-header]')];
    if (!popdowns.length) return;
    const mobile = matchMedia('(max-width: 767px), (pointer: coarse)');
    const style = document.createElement('style');
    style.textContent = `
      @media (max-width: 767px), (pointer: coarse) {
        search-popdown[data-popdown-in-header] .search-popdown__body--fixed {
          translate: 0 var(--hm-search-shift, 0px);
        }
        search-popdown[data-popdown-in-header] .search-popdown__results {
          height: var(--hm-search-available, 40svh);
          max-height: var(--hm-search-available, 40svh);
        }
        search-popdown[data-popdown-in-header] .search-popdown__results > .predictive-search,
        search-popdown[data-popdown-in-header] .search-popdown__results > .popular-searches {
          box-sizing: border-box;
          margin-top: 0;
          max-height: var(--hm-search-available, 40svh);
          padding-top: 16px;
          padding-bottom: calc(80px + env(safe-area-inset-bottom, 0px));
          overflow-y: auto;
          overscroll-behavior-y: contain;
          touch-action: pan-y;
          -webkit-overflow-scrolling: touch;
          scroll-padding-top: 16px;
          scroll-padding-bottom: calc(80px + env(safe-area-inset-bottom, 0px));
        }
      }`;
    document.head.append(style);
    let frame;
    const update = () => {
      frame = null;
      const viewport = window.visualViewport;
      const top = (viewport?.offsetTop || 0) + 12;
      const bottom = (viewport?.offsetTop || 0) + (viewport?.height || window.innerHeight) - 12;
      popdowns.forEach(popdown => {
        const body = popdown.querySelector('.search-popdown__body--fixed');
        body.style.removeProperty('--hm-search-shift');
        body.style.removeProperty('--hm-search-available');
        if (!mobile.matches || !popdown.querySelector('details[open]')) return;
        const input = popdown.querySelector('.search-form__input-holder').getBoundingClientRect();
        // Keep the input and some results visible when the keyboard opens.
        const shift = Math.max(top - input.top, Math.min(0, bottom - input.bottom - 180));
        body.style.setProperty('--hm-search-shift', `${shift}px`);
        const resultsTop = popdown.querySelector('.search-popdown__results').getBoundingClientRect().top;
        body.style.setProperty('--hm-search-available', `${Math.max(0, bottom - resultsTop)}px`);
      });
    };
    const schedule = () => { if (!frame) frame = requestAnimationFrame(update); };
    popdowns.forEach(popdown => {
      new MutationObserver(schedule).observe(popdown, {subtree: true, childList: true, attributes: true, attributeFilter: ['open', 'class']});
      popdown.addEventListener('transitionend', schedule);
      popdown.addEventListener('input', () => {
        popdown.querySelectorAll('.predictive-search, .popular-searches').forEach(results => { results.scrollTop = 0; });
        schedule();
      });
    });
    window.addEventListener('resize', schedule, {passive: true});
    window.visualViewport?.addEventListener('resize', schedule, {passive: true});
    window.visualViewport?.addEventListener('scroll', schedule, {passive: true});
    mobile.addEventListener('change', schedule);
    schedule();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
